export default "__VITE_ASSET__C4oR7uAm__"